<script setup lang="ts">
// Props
const props = defineProps({
  /**
   * The layout type to determine the visual arrangement of the component
   * @type {string} - The layout style of the footer.
   * @required false
   */
  layout: {
    type: String,
    required: false,
  },
});

/**
 * Localization Logic
 */
const { t } = useI18n();

// Check if the layout is 'maintenance'
const isMaintenanceLayout = computed(() => props.layout === "maintenance");
</script>

<template>
  <v-footer
    app
    class="flex-column bg-white py-4 text-center"
    aria-labelledby="footer-title"
    style="position: relative"
  >
    <!-- Footer Title for ARIA -->
    <h2 id="footer-title" class="d-sr-only">
      {{ t("footer.navigation_title") }}
    </h2>

    <!-- Copyright Section -->
    <v-row
      class="pt-2 d-flex justify-end align-end"
      aria-labelledby="footer-copyright"
    >
      <v-col>
        <!-- Hidden heading for screen readers -->
        <h3 id="footer-copyright" class="d-sr-only">
          {{ t("footer.copyright_title") }}
        </h3>

        <!-- Current year and links to the company websites -->
        <span class="text-body-2">
          {{ t("footer.copyright_prefix") }} © {{ new Date().getFullYear() }} -
        </span>

        <!-- SKYWARE Group with Tooltip -->
        <client-only>
          <v-tooltip location="bottom" :open-delay="700" :close-delay="300">
            <template v-slot:activator="{ props }">
              <NuxtLink
                to="http://www.skyware-group.com/"
                target="_blank"
                v-bind="props"
                class="text-body-2 font-weight-bold"
                :class="isMaintenanceLayout ? 'text-black' : 'text-primary'"
              >
                {{ t("footer.skyware_group") }}
              </NuxtLink>
            </template>

            <!-- Tooltip text -->
            <span>{{ t("tooltips.footer.skyware_group") }}</span>
          </v-tooltip>
        </client-only>

        <!-- Separator - '|' -->
        <span aria-hidden="true"> | </span>

        <!-- LIMS iLab with Tooltip -->
        <client-only>
          <v-tooltip location="bottom" :open-delay="700" :close-delay="300">
            <template v-slot:activator="{ props }">
              <NuxtLink
                to="http://www.skyware-group.com/"
                target="_blank"
                v-bind="props"
                class="text-body-2 font-weight-bold"
                :class="isMaintenanceLayout ? 'text-black' : 'text-primary'"
              >
                {{ t("footer.lims_ilab") }}
              </NuxtLink>
            </template>

            <!-- Tooltip text -->
            <span>{{ t("tooltips.footer.lims_ilab") }}</span>
          </v-tooltip>
        </client-only>

        <!-- Current version -->
        <span class="text-body-2" :aria-label="t('footer.version_aria_label')">
          | {{ t("footer.version") }} 4.6.0.10357
        </span>
      </v-col>
    </v-row>
  </v-footer>
</template>
